
export const DOWNLOAD_PDF_HTML_SANCTIONS_STYLES = `

    
    .header-ei {
        background-color: #373737;
        color: #fff;
        font-size: 10px;
        min-height: 43px;
        min-width: 1024px;
        position: relative;
        z-index: 90;
        margin-bottom: 30px;
    }
    
    .header-ei__logo {
        color: white;
        height: 43px;        
        padding: 0 15px;
        position: absolute;
        text-decoration: none;
        z-index: 1;
    }
    
    .header-ei__logo--company {
        font-size: 14px;
        font-weight: 400;
        position: relative;
        top: 2px;
    }
        
    .header__logo--product {
        font-size: 20px;
        position: relative;
        top: 0;
    }
    
    .header-ei__placeholder {
        border-top: 1px solid black;
        padding-top: 43px;
    }
    
    .submenu {
        background-color: #f4f4f5;
        border-bottom: 1px solid #d2d4d5;
    }
    
    
    .sanction-reports__page-content--source-information {
        margin-top: 20px;
        padding-top: 10px;        
    }
    
    .about-this-source__header {
        margin-top: 20px;
        border-bottom: 1px solid #bcbec0;
        font-size: 18px;
        padding: 1px 0 5px 0;    
    }
    
    .content-summary__header {
        margin-top: 20px;
        border-bottom: 1px solid #bcbec0;
        font-size: 18px;
        padding: 1px 0 5px 0;    
    }
    
    .pagebreak { 
        page-break-before: always; 
    }
    
`;



// WEBPACK FOOTER //
// ./src/scripts/reusable/DeliveryIcons/DeliveryIcons.DownloadPfdHtmlSyles.Sanctions.jsx